<template>
  <v-row align="center" justify="center" v-if="game && game.type">
    <v-col cols="12" class="game-questions-container">
      <v-row justify="space-between" class="pt-2 px-2" align="center">
        <v-col cols="12" md="6">
          <v-row justify="start">
            <v-btn rounded color="main_pink" class="px-2 white--text top-btns"
                   @click="createQuestion()"
            >
              {{ $t('pages.createGame.createQuestion') }}
            </v-btn>
            <v-btn color="main_pink" outlined rounded @click="questionsPoolModal=true" class="mx-2 top-btns">
              {{ $t("pages.createGame.theQuestionsPool") }}
            </v-btn>
            <play-button :game="game" class="hidden-sm-and-down" />
          </v-row>
        </v-col>
        <v-col cols="12" md="6">
          <v-row class="justify-start justify-md-end mt-1 mt-md-0">
            <play-button :game="game" class="hidden-md-and-up" />
            <v-btn icon v-if="game.type" @click="openHelpDialog" class="pt-1">
              <v-img max-width="30" src="/img/help_wheel.png" class="d-inline-block" />
            </v-btn>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    small
                    v-bind="attrs"
                    link
                    elevation="0"
                    color="transparent"
                    class="ml-1 mr-2 mb-2 game-toolbar-btn"
                    v-on="on"
                    @click.prevent.stop="onShare"
                >
                  <v-icon color="grey darken-1">mdi-share-variant</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("generics.share") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    small
                    color="transparent"
                    elevation="0"
                    class="ml-2 mb-2 game-toolbar-btn"
                    @click="doRemove(game)"
                    v-bind="attrs"
                    v-on="on"
                >
                  <v-icon color="grey darken-1">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("generics.delete") }}</span>
            </v-tooltip>
            <v-text-field
                outlined rounded dense hide-details="auto"
                v-model="questionText"
                clearable
                prepend-inner-icon="mdi-magnify"
                class="search-field"
            />
          </v-row>
        </v-col>
      </v-row>
      <v-row class="no-gutters py-1" v-if="game.type">
        <span class="px-1">{{ $t('pages.createGame.min') + ": " + game.type.min_questions }}</span>
        <span class="px-1">{{ $t('pages.createGame.selected') + ": " + questions.length }}</span>
      </v-row>
      <v-divider />
      <v-row v-if="auth.is_multi_user_company">
        <v-col>
          <v-alert dense text type="info">
            <strong>שימו &#10084;</strong>
            -
            {{ $t('pages.createGame.commonContent') }}
          </v-alert>
        </v-col>
      </v-row>
      <v-row justify="center" v-if="!this.questions || !this.questions.length">
        <v-col cols="auto" align="center" class="text-h5">
          <div>{{ $t('pages.createGame.noQuestionYet') }}</div>
          <v-btn text @click="createQuestion()">{{ $t('pages.createGame.clickToAddQuestion') }}</v-btn>
        </v-col>
      </v-row>
      <v-list subheader>
        <draggable v-model="questionsToShow">
          <transition-group>
            <div v-for="(question, index) in questionsToShow" :key="question.id">
              <game-question-row :index="index" @edit="onEdit(question)" @delete="doDelete(question)"
                                 :question="question" />
              <v-divider></v-divider>
            </div>
          </transition-group>
        </draggable>
      </v-list>
      <popup-dialog v-model="questionsModal" rounded-xl>
        <span slot="header">{{ $t('pages.createGame.createQuestion') }}</span>
        <question-form
            v-if="questionsModal"
            :from-game-menu="fromGameMenu"
            @save="addQuestion"
            @cancel="questionsModal = false"
        />
      </popup-dialog>
      <popup-dialog v-model="questionsPoolModal" rounded-xl>
        <span slot="header">{{ $t('pages.createGame.questionsPool') }}</span>
        <questions-pool
            :selected-questions="questions"
            @add="addQuestion"
        />
      </popup-dialog>
      </v-col>
  </v-row>
  <v-row v-else justify="center" align="center">
    <v-col cols="auto" align="center" class="text-h5">
      <v-progress-circular
          indeterminate
          color="main_pink"
          size="100"
          width="5" />
    </v-col>
  </v-row>

</template>

<script>
import QuestionsPool from "src/view/games/QuestionsPool";
import { types as TypeGames } from "src/store/modules/Game.module";
import { types as TypeGameQuestion } from "src/store/modules/GameQuestion.module";
import { types } from "root/packages/closeapp/QuestionsManager/assets/store/Question.module";
import QuestionForm from "root/packages/closeapp/QuestionsManager/assets/views/questions/QuestionForm";
import draggable from "vuedraggable";
import GameQuestionRow from "./GameQuestionRow";
import { uniqueId } from "lodash";
import GameDisplaySelect from "src/view/games/GameDisplaySelect";
import GameScreenSelect from "src/view/games/GameScreenSelect";

import PlayButton from "src/view/gameQuestions/PlayButton";

export default {
  name: "GameQuestionView",
  components: {
    PlayButton,
    GameQuestionRow,
    QuestionForm,
    QuestionsPool,
    draggable,
    GameDisplaySelect,
    GameScreenSelect
  },
  data() {
    return {
      questionsModal: false,
      questionsPoolModal: false,
      fromGameMenu: true,
      questionText: "",


    };
  },
  computed: {
    questions() {
      return this.$store.state.GameModule.game.questions || [];
    },
    questionsToShow: {
      get() {
        return this.questions.filter((question) => {
          return question.question.includes(this.questionText || "") || question.tags.some((tag) =>
              tag.name.includes(this.questionText || "")
          );
        });
      },
      set(val) {
        this.reorderQuestions(val);
      },
    },
    game() {
      return this.$store.state.GameModule.game;
    },
    auth() {
      return this.$store.state.AuthModule.user;
    }
  },
  async created() {
    await this.$store.dispatch(TypeGames.GET, this.$route.params.id);
  },
  methods: {
    async doRemove(game) {
        this.$emit('delete');
    },
    openHelpDialog() {
      this.$emit("openHelpDialog", {
        game: this.game,
        type: "game",
      });
    },
    onShare() {
      this.$emit("share", this.game);
    },
    async addQuestion(q) {
      this.questionsModal = false;
      await this.$store.dispatch(TypeGameQuestion.SAVE, {
        game_id: this.game.id,
        question_id: q.id,
        sort: this.latest() + 1,
      });
      await this.$store.dispatch(TypeGames.GET, this.game.id);
    },
    async removeQuestion(q) {
      await this.$store.dispatch(TypeGameQuestion.REMOVE, q);
      await this.$store.dispatch(TypeGames.GET, this.game.id);
      await this.$store.dispatch(types.FETCH);
    },
    async reorderQuestions(questions) {
      const reorderedQuestions = questions.map((question, index) => {
        question.sort = index;
        return question;
      });
      this.updateQuestionLocally(reorderedQuestions);
      try {
        await this.$store.dispatch(TypeGameQuestion.REORDER, { gameId: this.game.id, questions: reorderedQuestions });
        await this.$store.dispatch(TypeGames.GET, this.game.id);
      } catch (e) {
        // eslint-disable-next-line no-undef
        await this.$notification.error(
            "חלה שגיאה בעדכון השרת",
            "נא לנסות שוב מאוחר יותר"
        );

      }
    },
    createQuestion() {
      const question = {};
      if (!this.game.type.is_default_only_one_true_answer)
        question.answers = [{ id: uniqueId("notreal") }, { id: uniqueId("notreal") }, { id: uniqueId("notreal") }];
      this.$store.commit(types.CREATE, question);
      this.questionsModal = true;
    },
    async doDelete(question) {
      const response = await this.$notification.warning(
          this.$t("pages.mygames.popupDeleteQuestion"),
          this.$t("pages.mygames.popupDeleteQuestionSubtitle"),
          {
            confirmButtonText: this.$t("generics.accept"),
            cancelButtonText: this.$t("generics.cancel")
          }
      );
      if (response.isConfirmed) {
        this.deleteQuestion(question);
      }
    },
    async deleteQuestion(question) {
      const response = await this.$store.dispatch(types.REMOVE, question);
      if (response.id) {
        this.$notification.success("השאלה נמחקה");
        await this.removeQuestion(question);
      }
    },
    onEdit(question) {
      this.$store.commit(types.GET, question);
      this.questionsModal = true;
    },
    updateQuestionLocally(questions) {
      const gameClone = Object.assign({}, this.game);
      gameClone.questions = questions;
      this.$store.commit(TypeGames.GET, gameClone);
    },
    latest() {
      if (!this.questions.length) {
        return 0;
      }
      return Math.max(...this.questions.map((question) => question.sort));
    },
  },
};
</script>
<style scoped lang="scss">
.game-questions-container {
  background-color: #fff;
  border-radius: 10px;
  min-height: 70vh;
  position: relative;
  max-width: 1100px;
}

.search-field {
  max-width: 150px;
  height: 36px;
}

.top-btns {
  width: 150px;
}

.game-question {
  cursor: grabbing;
}

</style>
